import React from 'react';
import { useNavigate } from "react-router";

// Components
import CustomersFilters from './filters';
import { DataGrid, EditButton, FabContainer, CreateFab } from '@arredo/reactjs-ui';

// Material UI
import { Paper, Typography, Grid, Box } from '@mui/material';

// Hooks
import useAuthorize from '../../hooks/user/useAuthorize';
import useCustomers from '../../hooks/customers/useCustomers';
import useQueryString from '../../hooks/queryString/useQueryString';

// Models
import { Permissions } from '../../models/Roles';
import { columns, title } from '../../models/CustomerEntity';

const Customer = () => {
    const isAuthorized = useAuthorize();
    const push = useNavigate();
    const { setParameterSearch, filters, clearFilters } = useQueryString();
    const { customers, loading, totalPage } = useCustomers(filters);

    const handleChangePage = (e, page) =>
        setParameterSearch({
            ...filters,
            pageNumber: Number(page)
        });

    return (
        <>
            <Grid container spacing={1}>
                <Grid size={12}>
                    <Box component={Paper} display='flex' paddingX={2} paddingY={1} alignContent='center'>
                        <Typography variant="h3" align='center'>
                            {title}
                        </Typography>
                    </Box>
                </Grid>
                <Grid size={12}>
                    <CustomersFilters
                        filters={filters}
                        setFilters={setParameterSearch}
                        clearFilters={clearFilters}
                    />
                </Grid>
                <Grid size={12}>
                    <DataGrid
                        columns={columns}
                        rows={customers}
                        loading={loading}
                        paginationProps={{
                            count: totalPage,
                            page: filters?.pageNumber || 1,
                            onChange: handleChangePage
                        }}
                        actions={({ row }) => (
                            <>
                                {
                                    isAuthorized([Permissions.CustomerCreate]) &&
                                    <EditButton to={`/customers/${row.id}/update`} />
                                }
                            </>
                        )}
                    />
                </Grid>
            </Grid>
            <FabContainer>
                {isAuthorized([Permissions.CustomerEdit]) && <CreateFab onClick={() => push('/customers/create')} />}
            </FabContainer>
        </>
    );
}

export default Customer;